/**
 * POLYFILLS
 *
 * This `core-js/stable` import _must_ be the first import in the app index
 * This is configured by react-scripts + babel-preset-env to add all polyfills
 * required for browsers in our package.json `browserslist`.
 *
 * Avoid `react-app-polyfill` as it has caused hard-to-trace issues in IE
 */
import 'core-js/stable'

import React from 'react'
import ReactDOM from 'react-dom'

import {AppLoader} from 'containers/AppLoader'

import '@invitae/ids-sass/ids-sass-grid-transitional.scss'
import '@invitae/ids-sass/dist/main.css'
import '@invitae/nucleobase/dist/main.css'
import './index.scss'
import '@invitae/header-footer/dist/main.css'

ReactDOM.render(<AppLoader />, document.getElementById('root'))
